// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"298":"33a863202d74f099","773":"9b51f8b1fe908849"}[chunkId] + ".js";
};